var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlankfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3605 5.20039L10.7371 0.576953C10.6082 0.448047 10.4342 0.375 10.2516 0.375H1.125C0.744727 0.375 0.4375 0.682227 0.4375 1.0625V18.9375C0.4375 19.3178 0.744727 19.625 1.125 19.625H14.875C15.2553 19.625 15.5625 19.3178 15.5625 18.9375V5.68809C15.5625 5.50547 15.4895 5.3293 15.3605 5.20039ZM13.977 6.00391H9.93359V1.96055L13.977 6.00391ZM14.0156 18.0781H1.98438V1.92188H8.47266V6.5625C8.47266 6.80182 8.56772 7.03133 8.73695 7.20055C8.90617 7.36978 9.13568 7.46484 9.375 7.46484H14.0156V18.0781Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankfile);
export default __webpack_public_path__ + "static/media/blankfile.f5bad25d5f82f75f64147ef25e96b0d0.svg";
export { ForwardRef as ReactComponent };